import { Component } from "react";

import { connect } from "react-redux";

export class UI extends Component {
  componentDidMount() {
    const role = this.props.user?.role_selected;

    role && this.props.history.push(`/ui/${role}/dashboard`);
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(UI);
